/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/seccion'

export default {
    get: params => {
        let customRoute = `${route}?campus_id=${params.campusID}&expand=campus,status_description&search=${params.filter}`
        switch (params.seccionEstado) {
            case "2": customRoute = `${route}?campus_id=${params.campusID}&estado=1&expand=campus,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?campus_id=${params.campusID}&estado=0&expand=campus,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,nombre&expand=status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=campus,status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=campus,status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=campus,status_description`)
}
